import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "M418.75 0H81.25C36.377 0 0 36.377 0 81.25v337.5A81.25 81.25 0 0 0 81.25 500h337.5A81.25 81.25 0 0 0 500 418.75V81.25A81.25 81.25 0 0 0 418.75 0M370 276.25c0 1.25 0 2.5-2.5 3.75L133.75 397.5c-1.25 1.25-3.75-1.25-3.75-2.5v-60c0-1.25 0-2.5 1.25-2.5l170-85-170-86.25c-1.25 0-1.25-1.25-1.25-2.5v-60c0-1.25 2.5-3.75 3.75-2.5l233.75 117.5a6.25 6.25 0 0 1 2.5 5z"
    }, null, -1)
  ]))]))
}
export default { render: render }